import React from "react";
import logo from "../assets/logo-1.png";
import founder from "../assets/founder.jpg";

export default function About() {
  return (
    <div className="space-y-10">
      <section className="rounded-lg p-6 bg-white card-soft flex items-center gap-6">
        <img src={logo} alt="APAR logo" className="h-20 w-20 object-contain" />
        <div>
          <h1 className="text-3xl font-semibold h-font" style={{color:'var(--brand-deep)'}}>Apar Growth Partners</h1>
          <p className="mt-2 text-slate-600 b-font">Apar Growth Partners is an investment management firm focused on direct equity advisory. We combine deep fundamental research with patient, value-led investing to help clients build sustainable wealth.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto mt-8 section-pad px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
          <div className="md:col-span-2">
            <div className="glass card-glow hover-lift p-6 h-full flex flex-col">
              <h3 className="text-2xl font-semibold h-font" style={{ color: "var(--brand-deep)" }}>
                About Aman Shah
              </h3>

              <div className="mt-4 flex-1">
                <p className="text-slate-700 b-font">
                  Qualifications: CA, CFA (USA). Experience: 8+ years in fundamental equity research and investment advisory.
                </p>

                <p className="mt-4 text-slate-700 b-font">
                  Aman blends academic rigor with practical market experience. His interest in analysing businesses and stock markets began during his college years at R. A. Podar College, Mumbai, and has since grown into a passion for identifying long-term investment opportunities.
                </p>

                <p className="mt-4 text-slate-700 b-font">
                  He has been moulded in his initial years, at Jeetay Investments Private Ltd., a SEBI-registered Portfolio Management Services (PMS) firm having AUM of INR 1000 Cr. At Jeetay, he researched on a wide range of industries like BFSI, Capital goods, Hospitality, EPC companies, etc. and also assisted the fund manager in portfolio management. This dual exposure gave him both a stock-level perspective and a broader understanding of portfolio construction.
                </p>

                <p className="mt-4 text-slate-700 b-font">
                  At Apar, Aman attempts to guide his clients on their journey toward sustainable wealth creation, with patience and discipline at the core of his approach.
                </p>
              </div>

              <div className="mt-6 flex items-center gap-3">
                <a href="/Investor-Charter.docx" className="text-green-700 underline underline-offset-2 text-sm" target="_blank" rel="noreferrer">Download Investor Charter</a>
                <a href="#contact" className="ml-4 bg-green-700 hover:bg-green-800 text-white px-4 py-2 rounded-md text-sm">Book a Call</a>
              </div>
            </div>
          </div>

          <div className="order-first md:order-last">
            <div className="glass card-glow hover-lift p-4 h-full flex items-start md:items-center">
              <div className="w-full">
                <img
                  src={founder}
                  alt="Aman Shah"
                  className="w-full h-44 md:h-[320px] object-cover rounded-md"
                />
                <div className="mt-3">
                  <h4 className="font-semibold">Aman Shah</h4>
                  <div className="text-sm text-slate-600">Founder & Lead Adviser</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
